module.exports = __webpack_public_path__ + "img/home-lifestyle.33ff5f15.jpg";